import { render, staticRenderFns } from "./rk-select.vue?vue&type=template&id=48939fb2&scoped=true&"
import script from "./rk-select.vue?vue&type=script&lang=ts&"
export * from "./rk-select.vue?vue&type=script&lang=ts&"
import style0 from "./rk-select.vue?vue&type=style&index=0&id=48939fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48939fb2",
  null
  
)

export default component.exports